import { Route, Routes } from "react-router-dom";
import { AppShell } from "./components/layout/AppShell";
import { useAnalyticsTracking } from "./hooks/useAnalyticsTracking";
import { AdminDashboard } from "./routes/AdminDashboard";
import { CheckoutReturnPage } from "./routes/CheckoutReturnPage";
import { ContactPage } from "./routes/ContactPage";
import { DevQuestionReviewPage } from "./routes/DevQuestionReviewPage";
import { DevReportPage } from "./routes/DevReportPage";
import { HomePage } from "./routes/HomePage";
import { LegalPage } from "./routes/LegalPage";
import { LockedResultPage } from "./routes/LockedResultPage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { ReportPage } from "./routes/ReportPage";
import { ReportRenderPage } from "./routes/ReportRenderPage";
import { TestPage } from "./routes/TestPage";

function AppRoutes() {
  useAnalyticsTracking();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/test" element={<TestPage />} />
      <Route path="/result/:attemptId" element={<LockedResultPage />} />
      <Route path="/checkout/return" element={<CheckoutReturnPage />} />
      <Route path="/report/demo/:attemptId" element={<ReportPage />} />
      <Route path="/report-render/admin-preview/:attemptId" element={<ReportRenderPage />} />
      <Route path="/report-render/:reportId" element={<ReportRenderPage />} />
      <Route path="/report/:reportId" element={<ReportPage />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/dev/questions" element={<DevQuestionReviewPage />} />
      <Route path="/dev/report" element={<DevReportPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/legal/:page" element={<LegalPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export function App() {
  return (
    <AppShell>
      <AppRoutes />
    </AppShell>
  );
}
